import React from "react";
// import { Flex, Text, Checkbox } from "@digitallabs/one-x-ui";
import { Flex, Text, Checkbox } from "../../../resourses/digitallabs/one-x-ui";
import { MAIN_STEPS } from "../../../constants/constants";

const DynamicCheckbox = ({ field, fieldRefs, value, isMain, step, submitted, errors, updateValue, renderField, resetSubtree }) => {
  const fieldName = field.name;
  const checked = !!value;

  const handleChange = (e) => {
    const isChecked = e.target.checked;

    // update main value
    updateValue(fieldName, isChecked);

    // if unchecked → clear all sub questions
    if (!isChecked && field.sub_questions) {
      resetSubtree(field.sub_questions);
    }
  };

  const showSub = checked; // simple for checkbox

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      {/* Checkbox Row */}
      <Flex align="center" gap="sm">
        <Checkbox id={fieldName} checked={checked} onChange={handleChange} />

        <label htmlFor={fieldName} style={{ fontSize: "14px", color: "#4B5563" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {/* Bullet logic */}
            {step === MAIN_STEPS.CONFIRM_DETAILS || step === MAIN_STEPS.PERSONAL_DETAILS ? null : isMain ? (
              <img src="/form_bullet.png" alt="" style={{ height: "10px", marginRight: "4px" }} />
            ) : null}

            {field.question}
          </span>
        </label>
      </Flex>

      {/* Error */}
      {submitted && errors[fieldName] && (
        <Text
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "4px",
          }}
        >
          <img src="/warning_icon_form.png" alt="warn" style={{ height: "14px", marginRight: "4px" }} />
          {errors[fieldName]}
        </Text>
      )}

      {showSub &&
        field.sub_questions?.map((sub, i) => (
          <Flex
            key={sub.name ?? `${fieldName}-sub-${i}`}
            direction="column"
            style={{
              marginTop: "12px",
              marginLeft: "20px",
            }}
          >
            {renderField(sub)}
          </Flex>
        ))}
    </Flex>
  );
};

export default DynamicCheckbox;
